
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRefundDetailsDialog extends _Ext.ItemEditorDialog<ECommRefundDetailsRow> {
        protected getFormKey() { return ECommRefundDetailsForm.formKey; }
        protected getLocalTextPrefix() { return ECommRefundDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return ECommRefundDetailsRow.deletePermission; }
        protected getInsertPermission() { return ECommRefundDetailsRow.insertPermission; }
        protected getUpdatePermission() { return ECommRefundDetailsRow.updatePermission; }
        protected form = new ECommRefundDetailsForm(this.idPrefix);
        public ECommExchangerate;
        constructor() {
            super();

            this.element.width(250);
            q.setTextRightAlign(this.form.Amount);
            this.form.Mode.changeSelect2(e => {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.Mode.value];
                this.form.LedgerId.value = ledger.LedgerId.toString();

                q.showAndDisableField(this.form.LedgerId);
                switch (ledger.Type) {

                    case 280:
                        { //For Gift Voucher
                            Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                            q.hideField(this.form.ChequeDate, true);
                            q.hideField(this.form.ChequeNo, true);
                            q.hideField(this.form.RefNo, true);
                        }
                    case 283: { //For Gift Voucher
                        Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                        q.hideField(this.form.ChequeDate, true);
                        q.hideField(this.form.ChequeNo, true);
                        q.hideField(this.form.RefNo, false);
                    }
                    case 281: {//For Cheque
                        Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                        q.hideField(this.form.ChequeDate, false);
                        q.hideField(this.form.ChequeNo, false);

                        q.hideField(this.form.RefNo, true);
                    }
                    case 284: {//For Scheme Voucher
                        Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                        q.hideField(this.form.ChequeDate, true);
                        q.hideField(this.form.ChequeNo, true);
                        q.hideField(this.form.RefNo, true);
                    }
                        this.form.RefNo.value = "";
                }
            });
            this.form.RefNo.changeSelect2(e => {
                var details = Retail.GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                amount = 0;
                for (var i = 0; i < details.length; i++) {
                    amount += details[i].Amount;
                }
                this.form.Amount.value = amount;
                if (details[0].IsPartial) {

                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                } else { Serenity.EditorUtils.setReadOnly(this.form.Amount, false); }
            });
            this.form.Amount.changeSelect2(e => {
                if (this.form.Mode.value == "283") {
                    if (this.form.Amount.value > amount) {
                        Q.alert('Gift Voucher Limit Exceded');
                        this.form.Amount.value = amount;
                        return;
                    }
                }
            }); 
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.Mode.value != "") {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.Mode.value];
                switch (ledger.Type) {
                    case 283: {
                        var details = Retail.GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                        amount = 0;
                        for (var i = 0; i < details.length; i++) {
                            amount += details[i].Amount;
                        }
                    }
                    case 280: { //For Gift Voucher
                        Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                        q.hideField(this.form.ChequeDate, true);
                        q.hideField(this.form.ChequeNo, true);
                        // q.hideField(this.form.Scheme, true);
                        q.hideField(this.form.RefNo, true);
                    }
                    case 283: { //For Gift Voucher
                        Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                        q.hideField(this.form.ChequeDate, true);
                        q.hideField(this.form.ChequeNo, true);
                        //   q.hideField(this.form.Scheme, true);
                        q.hideField(this.form.RefNo, false);
                    }
                    case 281: {//For Cheque
                        Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                        q.hideField(this.form.ChequeDate, false);
                        q.hideField(this.form.ChequeNo, false);

                        // q.hideField(this.form.Scheme, true);
                        q.hideField(this.form.RefNo, true);
                    }
                    case 284: {//For Scheme Voucher
                        Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                        q.hideField(this.form.ChequeDate, true);
                        q.hideField(this.form.ChequeNo, true);
                        //   q.hideField(this.form.Scheme, false);
                        q.hideField(this.form.RefNo, true);
                        //this.form.Scheme.cascadeField = "CustomerId";
                        var customerid = (this.parentEditor.parentDialog as ECommRefundDialog).form.POSCustomerId.value;
                        if (customerid == undefined) {
                            Q.alert('Please Select Customer');
                            this.dialogClose();
                        }
                    }
                }

            } else {
                // q.hideField(this.form.Scheme, true);
                q.hideField(this.form.ChequeNo, true);
                q.hideField(this.form.ChequeDate, true);
            }
        }
        validateBeforeSave() {
            super.validateBeforeSave();
            var refundableamount = (this.parentEditor.parentDialog as ECommRefundDialog).form.RefundECommsible.value;
            if (this.form.Amount.value != refundableamount) {
                q.alert("", "Refundable Amount should match", true, 2999);
                return false;
            }
            return true;

        }

    }
}